$(() => {
  $('.registration-form iframe').on('load', () => {
    $('#registration-form')[0].scrollIntoView();
  });
});
